import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { LicenseContentProps } from "models/propTypes/settingsPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const LicenseContent: React.FC<LicenseContentProps> = ({ moduleName, gitHubLink, licenceUrl, infoText }) => {
  return (
    <Grid container direction="column" className={cssExports.lincenseInfoContainer} rowGap={2}>
      <Grid item container direction="column">
        <Grid item className={cssExports.title}>
          {moduleName}
        </Grid>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.GithubRepo)}:{" "}
          <a className={cssExports.linkText} href={gitHubLink.url}>
            {gitHubLink.text}
          </a>
        </Grid>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.About.License)}:{" "}
          <a className={cssExports.linkText} href={licenceUrl}>
            {licenceUrl}
          </a>
        </Grid>
      </Grid>
      <Grid item>{infoText}</Grid>
    </Grid>
  );
};

export default LicenseContent;
